<template>
  <div
    class="h-full flex flex-col font-sans text-[#1d1d1f] dark:text-[#f5f5f7] bg-[#F5F5F7] dark:bg-black overflow-hidden relative"
  >
    <header class="flex-none px-6 pt-6 pb-2">
      <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div>
          <h1
            class="text-[32px] font-bold tracking-tight leading-none text-[#1d1d1f] dark:text-white"
          >
            Minhas
            <span
              class="text-transparent bg-clip-text bg-gradient-to-r from-[#7B2CBF] to-[#9D4EDD]"
              >Tarefas</span
            >
          </h1>
          <p class="text-[13px] font-medium text-[#86868b] mt-1">Organize seu fluxo de trabalho.</p>
        </div>
        <div class="flex items-center gap-3">
          <button
            @click="openAdd()"
            class="flex items-center gap-2 bg-[#1d1d1f] dark:bg-white text-white dark:text-black px-4 py-2 rounded-full font-semibold text-[13px] shadow-lg hover:opacity-90 transition-opacity active:scale-95"
          >
            <span class="material-symbols-outlined text-[18px]">add</span> Nova Tarefa
          </button>
          <button
            @click="exportToCSV"
            class="h-9 w-9 grid place-items-center rounded-full bg-white dark:bg-[#1c1c1e] text-[#1d1d1f] dark:text-white shadow-sm border border-black/5 dark:border-white/10 hover:bg-[#f5f5f7] dark:hover:bg-[#2c2c2e] transition-colors"
          >
            <span class="material-symbols-outlined text-[18px]">ios_share</span>
          </button>
        </div>
      </div>

      <div v-if="!isMobile" class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <div
          class="bg-white/60 dark:bg-[#1c1c1e]/60 backdrop-blur-xl p-4 rounded-[20px] shadow-sm border border-white/20 dark:border-white/5 flex items-center gap-3"
        >
          <div
            class="h-10 w-10 rounded-full bg-[#7B2CBF]/10 flex items-center justify-center text-[#7B2CBF]"
          >
            <span class="material-symbols-outlined">fact_check</span>
          </div>
          <div>
            <p
              class="text-[11px] font-bold uppercase tracking-wider text-[#86868b]"
            >
              Total
            </p>
            <p class="text-xl font-bold text-[#1d1d1f] dark:text-white">
              {{ stats.total }}
            </p>
          </div>
        </div>
        <div
          class="bg-white/60 dark:bg-[#1c1c1e]/60 backdrop-blur-xl p-4 rounded-[20px] shadow-sm border border-white/20 dark:border-white/5 flex items-center gap-3"
        >
          <div
            class="h-10 w-10 rounded-full bg-[#34C759]/10 flex items-center justify-center text-[#34C759]"
          >
            <span class="material-symbols-outlined">check_circle</span>
          </div>
          <div>
            <p
              class="text-[11px] font-bold uppercase tracking-wider text-[#86868b]"
            >
              Feitas
            </p>
            <p class="text-xl font-bold text-[#1d1d1f] dark:text-white">
              {{ stats.done }}
            </p>
          </div>
        </div>
        <div
          class="bg-white/60 dark:bg-[#1c1c1e]/60 backdrop-blur-xl p-4 rounded-[20px] shadow-sm border border-white/20 dark:border-white/5 flex items-center gap-3"
        >
          <div
            class="h-10 w-10 rounded-full bg-[#FF9500]/10 flex items-center justify-center text-[#FF9500]"
          >
            <span class="material-symbols-outlined">today</span>
          </div>
          <div>
            <p
              class="text-[11px] font-bold uppercase tracking-wider text-[#86868b]"
            >
              Hoje
            </p>
            <p class="text-xl font-bold text-[#1d1d1f] dark:text-white">
              {{ stats.today }}
            </p>
          </div>
        </div>
        <div
          class="bg-white/60 dark:bg-[#1c1c1e]/60 backdrop-blur-xl p-4 rounded-[20px] shadow-sm border border-white/20 dark:border-white/5 flex items-center gap-3"
        >
          <div
            class="h-10 w-10 rounded-full bg-[#FF3B30]/10 flex items-center justify-center text-[#FF3B30]"
          >
            <span class="material-symbols-outlined">warning</span>
          </div>
          <div>
            <p
              class="text-[11px] font-bold uppercase tracking-wider text-[#86868b]"
            >
              Atraso
            </p>
            <p class="text-xl font-bold text-[#1d1d1f] dark:text-white">
              {{ stats.overdue }}
            </p>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col lg:flex-row items-center gap-3 bg-white/50 dark:bg-[#1c1c1e]/50 backdrop-blur-md p-1.5 rounded-[16px] border border-black/5 dark:border-white/5 mb-2"
      >
        <div class="relative w-full lg:w-64 group">
          <span
            class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-[#86868b] transition-colors group-focus-within:text-[#7B2CBF]"
          >
            search
          </span>
          <input
            v-model="searchQuery"
            placeholder="Buscar..."
            class="w-full h-9 pl-9 pr-3 text-[13px] bg-white dark:bg-[#2c2c2e] rounded-[10px] text-[#1d1d1f] dark:text-white placeholder-[#86868b] outline-none focus:ring-2 focus:ring-[#7B2CBF]/50 transition-all shadow-sm"
          />
        </div>

        <div class="h-4 w-px bg-black/10 dark:bg-white/10 hidden lg:block"></div>

        <div class="flex items-center gap-1 w-full overflow-x-auto no-scrollbar">
          <select
            v-model="mesSelecionado"
            class="h-9 px-3 text-[13px] font-medium bg-transparent text-[#1d1d1f] dark:text-white rounded-[10px] hover:bg-black/5 dark:hover:bg-white/10 border-none outline-none cursor-pointer"
          >
            <option value="">Todo Mês</option>
            <option v-for="mes in meses" :key="mes.valor" :value="mes.valor">
              {{ mes.nome }}
            </option>
          </select>
          <select
            v-model="anoSelecionado"
            class="h-9 px-3 text-[13px] font-medium bg-transparent text-[#1d1d1f] dark:text-white rounded-[10px] hover:bg-black/5 dark:hover:bg-white/10 border-none outline-none cursor-pointer"
          >
            <option value="">Todo Ano</option>
            <option v-for="ano in anosDisponiveis" :key="ano" :value="ano">
              {{ ano }}
            </option>
          </select>
        </div>

        <div
          class="ml-auto flex items-center bg-[#e3e3e8] dark:bg-[#2c2c2e] p-0.5 rounded-[10px] shrink-0"
        >
          <button
            @click="viewMode = 'status'"
            class="px-3 py-1.5 rounded-[8px] text-[12px] font-medium transition-all"
            :class="
              viewMode === 'status'
                ? 'bg-white dark:bg-[#636366] shadow-sm text-black dark:text-white'
                : 'text-[#86868b]'
            "
          >
            Status
          </button>
          <button
            @click="viewMode = 'priority'"
            class="px-3 py-1.5 rounded-[8px] text-[12px] font-medium transition-all"
            :class="
              viewMode === 'priority'
                ? 'bg-white dark:bg-[#636366] shadow-sm text-black dark:text-white'
                : 'text-[#86868b]'
            "
          >
            Prioridade
          </button>
        </div>
      </div>
    </header>

    <div v-if="isMobile" class="flex-1 overflow-y-auto custom-scroll px-4 pb-20 space-y-6">
      <div v-if="loading" class="space-y-4">
        <div
          v-for="i in 3"
          :key="i"
          class="h-40 rounded-[20px] bg-white/50 dark:bg-[#1c1c1e]/50 animate-pulse"
        ></div>
      </div>

      <div v-else v-for="column in currentColumns" :key="column.id" class="space-y-3">
        <div v-if="column.tasks.length > 0" class="flex items-center gap-2 px-2">
          <span class="w-2.5 h-2.5 rounded-full" :style="{ backgroundColor: column.color }"></span>
          <h3
            class="text-[15px] font-bold text-[#1d1d1f] dark:text-white uppercase tracking-wide"
          >
            {{ column.title }}
          </h3>
          <span
            class="text-[11px] font-bold text-[#86868b] bg-white dark:bg-[#1c1c1e] px-2 py-0.5 rounded-full shadow-sm"
            >{{ column.tasks.length }}</span
          >
        </div>

        <div
          v-for="task in column.tasks"
          :key="task.id"
          class="group relative bg-white dark:bg-[#1c1c1e] p-4 rounded-[18px] shadow-sm border border-black/5 dark:border-white/5 active:scale-[0.98] transition-all duration-200"
          :class="task.status === 'CONCLUIDO' ? 'opacity-60 grayscale-[0.5]' : ''"
        >
          <div class="flex items-start justify-between gap-3 mb-2">
            <p
              class="text-[15px] font-semibold text-[#1d1d1f] dark:text-white leading-snug"
            >
              {{ task.nome }}
            </p>
            <button
              @click="edit(task)"
              class="text-[#7B2CBF] px-2 py-1 bg-[#7B2CBF]/10 rounded-md text-[11px] font-bold shrink-0"
            >
              Editar
            </button>
          </div>

          <p
            v-if="task.descricao"
            class="text-[13px] text-[#86868b] line-clamp-2 mb-3 leading-relaxed"
          >
            {{ task.descricao }}
          </p>

          <div
            class="flex items-center justify-between mt-3 pt-3 border-t border-[#e5e5ea] dark:border-[#38383a]"
          >
            <div class="flex items-center gap-2">
              <span
                v-if="task.data"
                class="flex items-center gap-1 text-[11px] font-medium px-2 py-1 rounded-[6px]"
                :class="
                  isOverdue(task.data) && task.status !== 'CONCLUIDO'
                    ? 'bg-[#FF3B30]/10 text-[#FF3B30]'
                    : 'bg-[#f5f5f7] dark:bg-[#2c2c2e] text-[#86868b]'
                "
              >
                <span class="material-symbols-outlined text-[14px]">event</span>
                {{ formatDate(task.data) }}
              </span>
              <span
                class="text-[10px] font-bold px-2 py-1 rounded-[6px] uppercase tracking-wider"
                :class="
                  getPrioridadeInfo(task.prioridade).bgColor +
                  ' ' +
                  getPrioridadeInfo(task.prioridade).textColor
                "
              >
                {{ task.prioridade }}
              </span>
            </div>

            <button
              @click="askDelete(task.id)"
              class="text-[#FF3B30] p-1 rounded-full hover:bg-[#FF3B30]/10 transition-colors"
            >
              <span class="material-symbols-outlined text-[18px]">delete</span>
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="!allTarefas.length && !loading"
        class="flex flex-col items-center justify-center py-20 text-[#86868b] text-center"
      >
        <span class="material-symbols-outlined text-5xl mb-2 opacity-30">check_circle</span>
        <p>Tudo feito por aqui!</p>
      </div>
    </div>

    <div
      v-else
      class="flex-1 overflow-x-auto overflow-y-hidden px-6 pb-6 custom-scroll snap-x snap-mandatory"
    >
      <div class="flex h-full gap-6" :class="focusMode ? 'justify-center' : 'justify-start'">
        <template v-if="loading">
          <div
            v-for="i in 3"
            :key="i"
            class="min-w-[320px] w-[320px] h-full rounded-[24px] bg-white/50 dark:bg-[#1c1c1e]/50 animate-pulse"
          ></div>
        </template>

        <template v-else>
          <div
            v-for="column in currentColumns"
            :key="column.id"
            class="min-w-[320px] w-[320px] flex-none snap-start flex flex-col h-full bg-white dark:bg-[#1c1c1e] rounded-[24px] shadow-[0_4px_24px_-4px_rgba(0,0,0,0.05)] border border-black/5 dark:border-white/5 overflow-hidden transition-all duration-300"
            v-show="!focusMode || (focusMode && column.tasks.length)"
          >
            <div
              class="p-4 flex items-center justify-between border-b border-[#e5e5ea] dark:border-[#38383a] bg-white/50 dark:bg-[#1c1c1e]/50 backdrop-blur-md z-10 sticky top-0"
            >
              <div class="flex items-center gap-2">
                <span class="w-2.5 h-2.5 rounded-full" :style="{ backgroundColor: column.color }"></span>
                <h3 class="text-[15px] font-bold text-[#1d1d1f] dark:text-white">
                  {{ column.title }}
                </h3>
                <span
                  class="text-[11px] font-bold text-[#86868b] bg-[#f5f5f7] dark:bg-[#2c2c2e] px-2 py-0.5 rounded-full"
                  >{{ column.tasks.length }}</span
                >
              </div>
              <div class="flex gap-1">
                <button
                  @click="openAdd(column.id)"
                  class="h-7 w-7 rounded-full hover:bg-black/5 dark:hover:bg-white/10 grid place-items-center text-[#86868b] transition-colors"
                >
                  <span class="material-symbols-outlined text-[18px]">add</span>
                </button>
                <button
                  @click="toggleCollapse(column.id)"
                  class="h-7 w-7 rounded-full hover:bg-black/5 dark:hover:bg-white/10 grid place-items-center text-[#86868b] transition-colors"
                >
                  <span
                    class="material-symbols-outlined text-[18px]"
                    :class="{ 'rotate-180': collapsed[column.id] }"
                    >unfold_less</span
                  >
                </button>
              </div>
            </div>

            <div class="flex-1 overflow-y-auto custom-scroll bg-[#F5F5F7] dark:bg-[#000000] p-3 relative">
              <div
                v-if="!column.tasks.length"
                class="absolute inset-0 flex flex-col items-center justify-center text-[#86868b] opacity-40"
              >
                <span class="material-symbols-outlined text-4xl mb-2">drag_indicator</span>
                <p class="text-sm font-medium">Vazio</p>
              </div>

              <draggable
                :list="column.tasks"
                :group="{ name: 'tasks', pull: true, put: true }"
                item-key="id"
                :ghost-class="'ghost-card'"
                handle=".drag-handle"
                class="space-y-3 min-h-[100px]"
                @change="onTaskDropped($event, column.id)"
                v-show="!collapsed[column.id]"
              >
                <template #item="{ element: task }">
                  <div
                    class="group relative bg-white dark:bg-[#1c1c1e] p-4 rounded-[18px] shadow-sm hover:shadow-md transition-all duration-200 border border-transparent hover:border-[#7B2CBF]/30 cursor-default"
                    :class="task.status === 'CONCLUIDO' ? 'opacity-60' : ''"
                  >
                    <div class="flex items-start justify-between gap-3 mb-2">
                      <p
                        class="text-[14px] font-semibold text-[#1d1d1f] dark:text-white leading-tight line-clamp-2 break-words w-full"
                      >
                        {{ task.nome }}
                      </p>
                      <button
                        class="drag-handle opacity-0 group-hover:opacity-100 cursor-grab active:cursor-grabbing text-[#86868b] shrink-0"
                      >
                        <span class="material-symbols-outlined text-[18px]">drag_handle</span>
                      </button>
                    </div>

                    <p
                      v-if="task.descricao"
                      class="text-[12px] text-[#86868b] line-clamp-2 mb-3 leading-relaxed break-words"
                    >
                      {{ task.descricao }}
                    </p>

                    <div class="flex items-center justify-between mt-auto">
                      <div class="flex items-center gap-2">
                        <span
                          v-if="task.data"
                          class="flex items-center gap-1 text-[11px] font-medium px-2 py-1 rounded-[6px]"
                          :class="
                            isOverdue(task.data) && task.status !== 'CONCLUIDO'
                              ? 'bg-[#FF3B30]/10 text-[#FF3B30]'
                              : 'bg-[#f5f5f7] dark:bg-[#2c2c2e] text-[#86868b]'
                          "
                        >
                          <span class="material-symbols-outlined text-[14px]">event</span>
                          {{ formatDate(task.data) }}
                        </span>
                      </div>

                      <div
                        class="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity"
                      >
                        <button
                          @click="edit(task)"
                          class="h-7 w-7 rounded-full bg-[#f5f5f7] dark:bg-[#2c2c2e] hover:bg-[#7B2CBF] hover:text-white text-[#86868b] grid place-items-center transition-colors"
                        >
                          <span class="material-symbols-outlined text-[14px]">edit</span>
                        </button>
                        <button
                          @click="askDelete(task.id)"
                          class="h-7 w-7 rounded-full bg-[#f5f5f7] dark:bg-[#2c2c2e] hover:bg-[#FF3B30] hover:text-white text-[#86868b] grid place-items-center transition-colors"
                        >
                          <span class="material-symbols-outlined text-[14px]">delete</span>
                        </button>
                      </div>
                    </div>

                    <div class="absolute top-4 right-4" v-if="viewMode === 'status'">
                      <span
                        class="w-2 h-2 rounded-full"
                        :class="getPrioridadeInfo(task.prioridade).dot"
                      ></span>
                    </div>
                  </div>
                </template>
              </draggable>
            </div>
          </div>
        </template>

        <div class="w-2 shrink-0"></div>
      </div>
    </div>

    <transition name="modal-fade">
      <div
        v-if="showModal"
        @click.self="closeModal"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm p-4"
      >
        <div
          class="bg-white/90 dark:bg-[#1c1c1e]/90 backdrop-blur-2xl rounded-[24px] shadow-2xl w-full max-w-md border border-white/20 dark:border-white/10 overflow-hidden transform transition-all"
        >
          <div
            class="p-5 border-b border-[#e5e5ea] dark:border-[#38383a] flex justify-between items-center bg-white/50 dark:bg-[#2c2c2e]/50"
          >
            <h3 class="text-[17px] font-bold text-[#1d1d1f] dark:text-white">
              {{ isEditing ? 'Editar Tarefa' : 'Nova Tarefa' }}
            </h3>
            <button
              @click="closeModal"
              class="h-7 w-7 rounded-full bg-[#e3e3e8] dark:bg-[#3a3a3c] grid place-items-center text-[#86868b] hover:text-black dark:hover:text-white transition-colors"
            >
              <span class="material-symbols-outlined text-[16px]">close</span>
            </button>
          </div>
          <form @submit.prevent="submit" class="p-6 space-y-5">
            <div>
              <label
                class="block text-[12px] font-bold uppercase tracking-wider text-[#86868b] mb-1.5 ml-1"
                >Nome</label
              >
              <input
                v-model="form.nome"
                type="text"
                required
                class="w-full h-11 px-4 bg-[#F5F5F7] dark:bg-[#000000] rounded-[12px] text-[15px] text-[#1d1d1f] dark:text-white focus:ring-2 focus:ring-[#7B2CBF] outline-none border border-black/5 dark:border-white/10"
                placeholder="O que precisa ser feito?"
              />
            </div>
            <div>
              <label
                class="block text-[12px] font-bold uppercase tracking-wider text-[#86868b] mb-1.5 ml-1"
                >Descrição</label
              >
              <textarea
                v-model="form.descricao"
                rows="3"
                class="w-full p-4 bg-[#F5F5F7] dark:bg-[#000000] rounded-[12px] text-[14px] text-[#1d1d1f] dark:text-white focus:ring-2 focus:ring-[#7B2CBF] outline-none border border-black/5 dark:border-white/10 resize-none"
                placeholder="Detalhes adicionais..."
              ></textarea>
            </div>
            <div class="grid grid-cols-2 gap-4">
              <div>
                <label
                  class="block text-[12px] font-bold uppercase tracking-wider text-[#86868b] mb-1.5 ml-1"
                  >Data</label
                >
                <input
                  v-model="form.data"
                  type="date"
                  class="w-full h-11 px-3 bg-[#F5F5F7] dark:bg-[#000000] rounded-[12px] text-[14px] text-[#1d1d1f] dark:text-white focus:ring-2 focus:ring-[#7B2CBF] outline-none border border-black/5 dark:border-white/10"
                />
              </div>
              <div>
                <label
                  class="block text-[12px] font-bold uppercase tracking-wider text-[#86868b] mb-1.5 ml-1"
                  >Prioridade</label
                >
                <select
                  v-model="form.prioridade"
                  class="w-full h-11 px-3 bg-[#F5F5F7] dark:bg-[#000000] rounded-[12px] text-[14px] text-[#1d1d1f] dark:text-white focus:ring-2 focus:ring-[#7B2CBF] outline-none border border-black/5 dark:border-white/10 appearance-none"
                >
                  <option value="BAIXA">Baixa</option>
                  <option value="MEDIA">Média</option>
                  <option value="ALTA">Alta</option>
                  <option value="URGENTE">Urgente</option>
                </select>
              </div>
            </div>
            <div v-if="isEditing">
              <label
                class="block text-[12px] font-bold uppercase tracking-wider text-[#86868b] mb-1.5 ml-1"
                >Status</label
              >
              <select
                v-model="form.status"
                class="w-full h-11 px-3 bg-[#F5F5F7] dark:bg-[#000000] rounded-[12px] text-[14px] text-[#1d1d1f] dark:text-white focus:ring-2 focus:ring-[#7B2CBF] outline-none border border-black/5 dark:border-white/10 appearance-none"
              >
                <option value="A_FAZER">A Fazer</option>
                <option value="EM_ANDAMENTO">Em Andamento</option>
                <option value="CONCLUIDO">Concluído</option>
              </select>
            </div>
            <div class="pt-2 flex justify-end gap-3">
              <button
                type="button"
                @click="closeModal"
                class="px-5 py-2.5 rounded-[12px] text-[14px] font-semibold text-[#1d1d1f] dark:text-white hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
              >
                Cancelar
              </button>
              <button
                type="submit"
                :disabled="saving"
                class="px-5 py-2.5 rounded-[12px] bg-[#7B2CBF] hover:bg-[#5A189A] text-white text-[14px] font-semibold shadow-lg shadow-[#7B2CBF]/30 transition-all active:scale-95 disabled:opacity-50"
              >
                {{ saving ? 'Salvando...' : 'Confirmar' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>

    <transition name="modal-fade">
      <div
        v-if="showDeleteConfirm"
        @click.self="showDeleteConfirm = false"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm p-4"
      >
        <div
          class="bg-white/90 dark:bg-[#1c1c1e]/90 backdrop-blur-2xl rounded-[24px] shadow-2xl w-full max-w-sm border border-white/20 dark:border-white/10 p-6 text-center"
        >
          <div
            class="h-14 w-14 rounded-full bg-[#FF3B30]/10 text-[#FF3B30] grid place-items-center mx-auto mb-4"
          >
            <span class="material-symbols-outlined text-[28px]">delete</span>
          </div>
          <h3 class="text-[17px] font-bold text-[#1d1d1f] dark:text-white mb-2">
            Excluir Tarefa?
          </h3>
          <p class="text-[13px] text-[#86868b] mb-6">
            Esta ação é permanente e não pode ser desfeita.
          </p>
          <div class="grid grid-cols-2 gap-3">
            <button
              @click="showDeleteConfirm = false"
              class="py-2.5 rounded-[12px] font-semibold text-[13px] bg-[#e3e3e8] dark:bg-[#2c2c2e] text-[#1d1d1f] dark:text-white"
            >
              Cancelar
            </button>
            <button
              @click="doDelete"
              class="py-2.5 rounded-[12px] font-semibold text-[13px] bg-[#FF3B30] text-white shadow-lg shadow-red-500/30"
            >
              Excluir
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'
import draggable from 'vuedraggable'

const router = useRouter()
const apiUrl = 'https://backend.controlease.com.br/tarefas'
const allTarefas = ref([])
const loading = ref(true)
const saving = ref(false)
const searchQuery = ref('')
const mesSelecionado = ref('')
const anoSelecionado = ref('')
const viewMode = ref(localStorage.getItem('tasks:viewMode') || 'status')
const focusMode = ref(false)
const collapsed = ref({})
const showModal = ref(false)
const isEditing = ref(false)
const showDeleteConfirm = ref(false)
const toDeleteId = ref(null)
const form = ref({
  id: null,
  nome: '',
  descricao: '',
  data: '',
  status: 'A_FAZER',
  prioridade: 'MEDIA'
})

const statusColumns = [
  { id: 'A_FAZER', title: 'A Fazer', color: '#86868b' },
  { id: 'EM_ANDAMENTO', title: 'Em Andamento', color: '#7B2CBF' },
  { id: 'CONCLUIDO', title: 'Concluído', color: '#34C759' }
]
const priorityColumns = [
  { id: 'BAIXA', title: 'Baixa', color: '#86868b' },
  { id: 'MEDIA', title: 'Média', color: '#7B2CBF' },
  { id: 'ALTA', title: 'Alta', color: '#FF9500' },
  { id: 'URGENTE', title: 'Urgente', color: '#FF3B30' }
]

const meses = [
  { nome: 'Janeiro', valor: '01' },
  { nome: 'Fevereiro', valor: '02' },
  { nome: 'Março', valor: '03' },
  { nome: 'Abril', valor: '04' },
  { nome: 'Maio', valor: '05' },
  { nome: 'Junho', valor: '06' },
  { nome: 'Julho', valor: '07' },
  { nome: 'Agosto', valor: '08' },
  { nome: 'Setembro', valor: '09' },
  { nome: 'Outubro', valor: '10' },
  { nome: 'Novembro', valor: '11' },
  { nome: 'Dezembro', valor: '12' }
]

const authConfig = () => {
  const token = localStorage.getItem('token')
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {}
}
const getAnoAtual = () => String(new Date().getFullYear())
const getMesAtual = () => String(new Date().getMonth() + 1).padStart(2, '0')
const todayISO = computed(() => new Date().toISOString().split('T')[0])
const anosDisponiveis = computed(() => {
  const anos = new Set(
    allTarefas.value.map(t => t.data?.split('-')[0]).filter(Boolean)
  )
  return Array.from(anos).sort((a, b) => parseInt(b) - parseInt(a))
})

const filtered = computed(() => {
  return allTarefas.value.filter(t => {
    const [ano, mes] = t.data ? t.data.split('-') : [null, null]
    const byAno = !anoSelecionado.value || ano === anoSelecionado.value
    const byMes = !mesSelecionado.value || mes === mesSelecionado.value
    const byText =
      !searchQuery.value ||
      t.nome?.toLowerCase().includes(searchQuery.value.toLowerCase())
    return byAno && byMes && byText
  })
})

const sortTasks = (a, b) => {
  if (a.status === 'CONCLUIDO' && b.status !== 'CONCLUIDO') return 1
  if (b.status === 'CONCLUIDO' && a.status !== 'CONCLUIDO') return -1
  return (a.data || '9999').localeCompare(b.data || '9999')
}

const currentColumns = computed(() => {
  const base = (
    viewMode.value === 'status' ? statusColumns : priorityColumns
  ).map(c => ({ ...c, tasks: [] }))
  const field = viewMode.value === 'status' ? 'status' : 'prioridade'
  filtered.value.forEach(t => {
    const key = t[field] || (viewMode.value === 'status' ? 'A_FAZER' : 'MEDIA')
    const col = base.find(c => c.id === key)
    if (col) col.tasks.push(t)
  })
  base.forEach(c => c.tasks.sort(sortTasks))
  return base
})

const stats = computed(() => {
  const list = filtered.value
  return {
    total: list.length,
    done: list.filter(t => t.status === 'CONCLUIDO').length,
    today: list.filter(t => t.data === todayISO.value).length,
    overdue: list.filter(
      t => isOverdue(t.data) && t.status !== 'CONCLUIDO'
    ).length
  }
})

const onTaskDropped = async (event, newColumnId) => {
  if (!event?.added) return
  const task = event.added.element
  const field = viewMode.value === 'status' ? 'status' : 'prioridade'
  if (!task || task[field] === newColumnId) return
  const prev = task[field]
  task[field] = newColumnId
  try {
    await axios.put(`${apiUrl}/${task.id}`, task, authConfig())
  } catch (err) {
    task[field] = prev
  }
}

const isMobile = ref(false)
let mq
const setDevice = () => {
  isMobile.value = !!mq?.matches
}

const openAdd = columnId => {
  if (isMobile.value) {
    const field = viewMode.value === 'status' ? 'status' : 'prioridade'
    return router.push({
      name: 'TarefasAdd',
      query: columnId ? { [field]: columnId } : {}
    })
  }
  form.value = {
    id: null,
    nome: '',
    descricao: '',
    data: todayISO.value,
    status: 'A_FAZER',
    prioridade: 'MEDIA'
  }
  if (columnId) {
    const field = viewMode.value === 'status' ? 'status' : 'prioridade'
    form.value[field] = columnId
  }
  isEditing.value = false
  showModal.value = true
}

const edit = t => {
  if (isMobile.value) {
    return router.push({ name: 'TarefasEdit', params: { id: t.id } })
  }
  form.value = { ...t }
  isEditing.value = true
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
}

const submit = async () => {
  saving.value = true
  try {
    const payload = { ...form.value }
    if (isEditing.value) {
      await axios.put(`${apiUrl}/${payload.id}`, payload, authConfig())
    } else {
      await axios.post(apiUrl, payload, authConfig())
    }
    await fetchTarefas()
    closeModal()
  } catch (e) {
    alert('Erro ao salvar')
  } finally {
    saving.value = false
  }
}

const askDelete = id => {
  toDeleteId.value = id
  showDeleteConfirm.value = true
}

const doDelete = async () => {
  try {
    await axios.delete(`${apiUrl}/${toDeleteId.value}`, authConfig())
    await fetchTarefas()
  } catch (e) {
    alert('Erro ao excluir')
  } finally {
    showDeleteConfirm.value = false
  }
}

const formatDate = iso => {
  if (!iso) return ''
  const d = new Date(`${iso}T12:00:00`)
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' })
}
const isOverdue = iso => {
  if (!iso) return false
  const t = new Date()
  t.setHours(0, 0, 0, 0)
  return new Date(`${iso}T12:00:00`) < t
}
const getPrioridadeInfo = p => {
  switch (p) {
    case 'URGENTE':
      return {
        dot: 'bg-[#FF3B30]',
        bgColor: 'bg-[#FF3B30]/10',
        textColor: 'text-[#FF3B30]'
      }
    case 'ALTA':
      return {
        dot: 'bg-[#FF9500]',
        bgColor: 'bg-[#FF9500]/10',
        textColor: 'text-[#FF9500]'
      }
    case 'MEDIA':
      return {
        dot: 'bg-[#7B2CBF]',
        bgColor: 'bg-[#7B2CBF]/10',
        textColor: 'text-[#7B2CBF]'
      }
    default:
      return {
        dot: 'bg-[#86868b]',
        bgColor: 'bg-[#86868b]/10',
        textColor: 'text-[#86868b]'
      }
  }
}

const exportToCSV = () => {
  const list = filtered.value
  if (!list.length) return
  const rows = list.map(t =>
    [t.nome, t.status, t.prioridade, t.data].join(',')
  )
  const csv = 'Nome,Status,Prioridade,Data\n' + rows.join('\n')
  const blob = new Blob([csv], { type: 'text/csv' })
  const a = document.createElement('a')
  a.href = URL.createObjectURL(blob)
  a.download = 'tarefas.csv'
  a.click()
}

const fetchTarefas = async () => {
  loading.value = true
  try {
    const { data } = await axios.get(apiUrl, authConfig())
    allTarefas.value = (data || []).map(t => ({
      ...t,
      status: t.status || 'A_FAZER',
      prioridade: t.prioridade || 'MEDIA'
    }))
  } catch (e) {
    //
  } finally {
    setTimeout(() => {
      loading.value = false
    }, 300)
  }
}

const toggleCollapse = id => {
  collapsed.value[id] = !collapsed.value[id]
}
watch(viewMode, v => localStorage.setItem('tasks:viewMode', v))

onMounted(async () => {
  mesSelecionado.value = getMesAtual()
  anoSelecionado.value = getAnoAtual()
  await fetchTarefas()
  mq = window.matchMedia('(max-width: 767.98px)')
  setDevice()
  mq.addEventListener?.('change', setDevice)
})
onBeforeUnmount(() => {
  mq?.removeEventListener?.('change', setDevice)
})
</script>

<style scoped>
.font-sans {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif;
}
.custom-scroll::-webkit-scrollbar {
  width: 4px;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.dark .custom-scroll::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
}
.custom-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.ghost-card {
  @apply opacity-50 scale-95 border-2 border-dashed border-[#7B2CBF] bg-white/50 dark:bg-white/5 rounded-[18px];
}
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
